// extracted by mini-css-extract-plugin
export default {"AfterPayMessageContainer":"AfterPayMessage_AfterPayMessageContainer","afterpayInfo":"AfterPayMessage_afterpayInfo"};